import {
  BadgeCounter,
  Box,
  FilterIcon,
  IconButton,
  TableToolbar,
} from '@hivewatch/dark'
import type { ColorScheme } from '@hivewatch/dark'

interface SettingsTableToolbarIProps {
  colorScheme: ColorScheme
  filterButtonLabel: string
  filterButtonTestId: string
  filterCount: number
  onOpenFilters: () => void
  onSearchChange: (value: string) => void
  search: string
  searchPlaceholder: string
}

/**
 * Search-and-filter bar shared by the rebranded Settings tables: the dark
 * `TableToolbar` plus the applied-filter badge and the drawer trigger. Each
 * section owns its own drawer and renders it next to this bar.
 */
export const SettingsTableToolbar = ({
  colorScheme,
  filterButtonLabel,
  filterButtonTestId,
  filterCount,
  onOpenFilters,
  onSearchChange,
  search,
  searchPlaceholder,
}: SettingsTableToolbarIProps) => (
  <TableToolbar
    actions={
      <Box alignItems='center' display='flex' gap='8px'>
        {filterCount > 0 && (
          <BadgeCounter
            colorScheme={colorScheme}
            count={filterCount}
            variant='button'
          />
        )}
        <IconButton
          aria-label={filterButtonLabel}
          colorScheme={colorScheme}
          data-testid={filterButtonTestId}
          dimension={36}
          icon={<FilterIcon colorScheme={colorScheme} />}
          onClick={onOpenFilters}
        />
      </Box>
    }
    colorScheme={colorScheme}
    onChange={onSearchChange}
    placeholder={searchPlaceholder}
    value={search}
  />
)
